import { FC } from 'react'
import { Tag } from 'antd'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { toTitleCase } from '@signifyd/utils'
import { RunStatus } from '@signifyd/cypress'
import { statusTag } from 'utils/utils'

interface Props {
  runStatus: RunStatus | 'unknown'
}

const RunStatusTag: FC<Props> = ({ runStatus = 'unknown' }) => {
  if (
    runStatus === 'unknown' ||
    Object.keys(statusTag).every((key) => key !== runStatus)
  ) {
    return <Tag icon={<QuestionCircleOutlined />}>{toTitleCase(runStatus)}</Tag>
  }

  const runStatusTag = statusTag[runStatus]

  return (
    <Tag
      icon={runStatusTag?.icon}
      color={runStatusTag?.color}
      style={{ minWidth: '85px', textAlign: 'center' }}
    >
      {toTitleCase(runStatus)}
    </Tag>
  )
}

export default RunStatusTag
